import {TestScopesKey} from '../../../../packages/Tests/Tests.types'
import type {OrderByField, OrderDirection, TestScope} from '../../../../packages/Tests/Tests.types'
import {ViewType} from '../TestsFilter/TestsViewSelect/TestsViewSelect.utils'

export const getScopesLocator = ({
  testOccurrencesLocator,
  currentPage,
  count,
  scope,
  orderBy,
  order,
}: {
  testOccurrencesLocator: string
  currentPage?: number
  count?: number
  scope?: TestScope
  orderBy?: OrderByField | null | undefined
  order?: OrderDirection
}): string => {
  const scopeParts = [
    scope?.suite != null ? `suite:(value:(${scope.suite}),matchType:equals)` : '',
    scope?.package != null ? `package:(value:(${scope.package}),matchType:equals)` : '',
    scope?.class != null ? `class:(value:(${scope.class}),matchType:equals)` : '',
  ]
    .filter(Boolean)
    .join(',')
  const scopeLocator = scopeParts.length > 0 ? scopeParts : ''
  const orderLocator = orderBy != null && order != null ? `orderBy:(${orderBy}:${order})` : ''
  const countLocator = count != null ? `count:${count}` : ''
  const startLocator =
    currentPage != null && count != null ? `start:${(currentPage - 1) * count}` : ''
  return [
    `testOccurrences:(${testOccurrencesLocator})`,
    scopeLocator,
    orderLocator,
    countLocator,
    startLocator,
  ]
    .filter(Boolean)
    .join(',')
}
export const getScopeKeyByViewType = (view: ViewType): TestScopesKey => {
  switch (view) {
    case ViewType.SUITES:
      return TestScopesKey.SUITE

    case ViewType.PACKAGES:
      return TestScopesKey.PACKAGE

    case ViewType.CLASSES:
      return TestScopesKey.CLASS

    default:
      return TestScopesKey.SUITE
  }
}
